import { render, staticRenderFns } from "./FieldSetKeyValue.vue?vue&type=template&id=45cfa64e&lang=pug&"
import script from "./FieldSetKeyValue.vue?vue&type=script&lang=js&"
export * from "./FieldSetKeyValue.vue?vue&type=script&lang=js&"
import style0 from "./FieldSetKeyValue.vue?vue&type=style&index=0&id=45cfa64e&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports